import ApplyQardan from './qardan-hasana/apply/business'

export default ApplyQardan;
